import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastNotificationService } from '../core/toast-notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UIBlockingService } from '../core/ui-blocking.service';
import { SignUpService } from './sign-up.service';
import { GeneralApplicationRequest } from './DTOs/general-application-request';
import { MinorityCertificateType } from './DTOs/minority-certificate-type';
import { MbscSelect } from '@mobiscroll/angular';
import { NumberOfEmployeesOption } from './DTOs/number-of-employees-option';
import { CommonLibrary } from '../core/common-library';

@Component({
  selector: 'app-general-sign-up',
  templateUrl: './general-sign-up.component.html',
  providers: [UIBlockingService, MbscSelect],
  styleUrls: ["../../assets/css/create.css"],
  encapsulation: ViewEncapsulation.None
})
export class GeneralSignUpComponent {

  constructor(private signUpService: SignUpService
    , private blockUI: UIBlockingService
      , private router: Router
      , private route: ActivatedRoute
    , private notificationService: ToastNotificationService
    , private fb: FormBuilder
  ) { }
  applicationRequest: GeneralApplicationRequest = new GeneralApplicationRequest();
  currentStep = 1;
  maxStep = 3;
  onFinalStep = false;
  specialAppType = null;

  firstNameCtrl = new FormControl("firstName", [Validators.required]);
  lastNameCtrl = new FormControl("lastName", [Validators.required]);
  emailAddressCtrl = new FormControl("emailAddress", [Validators.required, Validators.email]);
  phoneNumberCtrl = new FormControl("phoneNumber", [Validators.required]);
  jobTitleCtrl = new FormControl("jobTitle");
  referredByCtrl = new FormControl("referredBy");
  brokerNameCtrl = new FormControl("lastName");
  brokerEmailCtrl = new FormControl("emailAddress", [Validators.email]);

  isBillingContactCtrl = new FormControl("isBillingContact", [Validators.required]);
  billingFirstNameCtrl = new FormControl("billingContactFirstName");
  billingLastNameCtrl = new FormControl("billingContactLastName");
  billingEmailCtrl = new FormControl("billingContactEmail");
  billingPhoneCtrl = new FormControl("billingContactPhone");

  isKeyContactCtrl = new FormControl("isKeyContact", [Validators.required]);
  keyFirstNameCtrl = new FormControl("keyContactFirstName");
  keyLastNameCtrl = new FormControl("keyContactLastName");
  keyEmailCtrl = new FormControl("keyContactEmail");
  keyPhoneCtrl = new FormControl("keyContactPhone");

  stepOneForm: FormGroup = new FormGroup({
    firstName: this.firstNameCtrl,
    lastName: this.lastNameCtrl,
    emailAddress: this.emailAddressCtrl,
    phoneNumber: this.phoneNumberCtrl,
    jobTitle: this.jobTitleCtrl,
    referredBy: this.referredByCtrl,
    isBillingContact: this.isBillingContactCtrl,
    billingContactFirstName: this.billingFirstNameCtrl,
    billingContactLastName: this.billingLastNameCtrl,
    billingContactEmail: this.billingEmailCtrl,
    billingContactPhone: this.billingPhoneCtrl,
    isKeyContact: this.isKeyContactCtrl,
    keyContactFirstName: this.keyFirstNameCtrl,
    keyContactLastName: this.keyLastNameCtrl,
    keyContactEmail: this.keyEmailCtrl,
    keyContactPhone: this.keyPhoneCtrl,
    brokerName: this.brokerNameCtrl,
    brokerEmail: this.brokerEmailCtrl,
  });

  firstName() { return this.stepOneForm.get('firstName').value }
  lastName() { return this.stepOneForm.get('lastName').value }
  emailAddress() { return this.stepOneForm.get('emailAddress').value }
  phoneNumber() { return this.stepOneForm.get('phoneNumber').value }
  jobTitle() { return this.stepOneForm.get('jobTitle').value }
  referredBy() { return this.stepOneForm.get('referredBy').value }
  isBillingContact() { return this.stepOneForm.get('isBillingContact').value }
  billingContactFirstName() { return this.stepOneForm.get('billingContactFirstName').value }
  billingContactLastName() { return this.stepOneForm.get('billingContactLastName').value }
  billingContactEmail() { return this.stepOneForm.get('billingContactEmail').value }
  billingContactPhone() { return this.stepOneForm.get('billingContactPhone').value }
  isKeyContact() { return this.stepOneForm.get('isKeyContact').value }
  keyContactFirstName() { return this.stepOneForm.get('keyContactFirstName').value }
  keyContactLastName() { return this.stepOneForm.get('keyContactLastName').value }
  keyContactEmail() { return this.stepOneForm.get('keyContactEmail').value }
  keyContactPhone() { return this.stepOneForm.get('keyContactPhone').value }
  brokerName() { return this.stepOneForm.get('brokerName').value }
  brokerEmail() { return this.stepOneForm.get('brokerEmail').value }

  companyNameCtrl = new FormControl("companyName", [Validators.required]);
  numberOfEmployeesCtrl = new FormControl("numberOfEmployees", [Validators.required, Validators.min(1)]);
  businessPhoneCtrl = new FormControl("businessPhone", [Validators.required]);
  businessAddressCtrl = new FormControl("businessAddress", [Validators.required]);
  cityCtrl = new FormControl("city", [Validators.required]);
  stateCtrl = new FormControl("State", [Validators.required]);
  zipCtrl = new FormControl("zip", [Validators.required]);
  isMinorityOwnedCertifiedCtrl = new FormControl("isMinorityOwnedCertified", [Validators.required]);
  minorityOwnedCertificateCtrl = new FormControl("minorityOwnedCertificates");

  stepTwoForm: FormGroup = new FormGroup({
    companyName: this.companyNameCtrl,
    numberOfEmployees: this.numberOfEmployeesCtrl,
    businessPhone: this.businessPhoneCtrl,
    businessAddress: this.businessAddressCtrl,
    city: this.cityCtrl,
    state: this.stateCtrl,
    zip: this.zipCtrl,
    isAlaskanNative: new FormControl("isAlaskanNative"),
    isAsian: new FormControl("isAsian"),
    isBlack: new FormControl("isBlack"),
    isDisability: new FormControl("isDisability"),
    isHispanic: new FormControl("isHispanic"),
    isLgbtq: new FormControl("isLgbtq"),
    isVeteran: new FormControl("isVeteran"),
    isWomen: new FormControl("isWomen"),
    isOtherMinority: new FormControl("isOtherMinority"),
    noneOfTheAbove: new FormControl("noneOfTheAbove"),
    isMinorityOwnedCertified: this.isMinorityOwnedCertifiedCtrl,
    minorityOwnedCertificates: this.minorityOwnedCertificateCtrl
  });

  minorityCertificateTypes: MinorityCertificateType[] = [];
  numberOfEmpoyeesOptions: NumberOfEmployeesOption[] = [];

  companyName() { return this.stepTwoForm.get('companyName').value }
  numberOfEmployees() { return this.stepTwoForm.get('numberOfEmployees').value }
  businessPhone() { return this.stepTwoForm.get('businessPhone').value }
  businessAddress() { return this.stepTwoForm.get('businessAddress').value }
  city() { return this.stepTwoForm.get('city').value }
  state() { return this.stepTwoForm.get('state').value }
  zip() { return this.stepTwoForm.get('zip').value }
  referredByTwo() { return this.stepTwoForm.get('referredBy').value }
  isAlaskanNative() { return this.stepTwoForm.get('isAlaskanNative').value }
  isAsian() { return this.stepTwoForm.get('isAsian').value }
  isBlack() { return this.stepTwoForm.get('isBlack').value }
  isDisability() { return this.stepTwoForm.get('isDisability').value }
  isHispanic() { return this.stepTwoForm.get('isHispanic').value }
  isLgbtq() { return this.stepTwoForm.get('isLgbtq').value }
  isVeteran() { return this.stepTwoForm.get('isVeteran').value }
  isWomen() { return this.stepTwoForm.get('isWomen').value }
  isOtherMinority() { return this.stepTwoForm.get('isOtherMinority').value }
  noneOfTheAbove() { return this.stepTwoForm.get('noneOfTheAbove').value }
  isMinorityOwnedCertified() { return this.stepTwoForm.get('isMinorityOwnedCertified').value }
  minorityOwnedCertificates() { return this.stepTwoForm.get('minorityOwnedCertificates').value }

  membershipLevelCtrl = new FormControl("membershipLevel", [Validators.required, Validators.min(1)]);
  paymentOptionsCtrl = new FormControl("paymentOptions");
  cardNumberCtrl = new FormControl("cardNumber", [Validators.required]);
  cardExpirationCtrl = new FormControl("cardExpiration", [Validators.required]);
  CVVCtrl = new FormControl("cvv", [Validators.required]);
  autoRenewCtrl = new FormControl("autoRenew");
  declinePacDonationCtrl = new FormControl("declinePacDonation");
  termsAndConditionsCtrl = new FormControl("termsAndConditions", [Validators.requiredTrue]);
  privacyPolicyCtrl = new FormControl("privacyPolicy", [Validators.requiredTrue]);

  routingNumberCtrl = new FormControl("routingNumber");
  accountNumber1Ctrl = new FormControl("accountNumber1");
  accountNumber2Ctrl = new FormControl("accountNumber2");


  stepThreeForm: FormGroup = new FormGroup({
    membershipLevel: this.membershipLevelCtrl,
    paymentOptions: this.paymentOptionsCtrl,
    cardNumber: this.cardNumberCtrl,
    cardExpiration: this.cardExpirationCtrl,
    cvv: this.CVVCtrl,
    routingNumber: this.routingNumberCtrl,
    accountNumber1: this.accountNumber1Ctrl,
    accountNumber2: this.accountNumber2Ctrl,
    autoRenew: this.autoRenewCtrl,
    declinePacDonation: this.declinePacDonationCtrl,
    termsAndConditions: this.termsAndConditionsCtrl,
    privacyPolicy: this.privacyPolicyCtrl
  });

  estimatedPrice: string = "Select a membership to see estimated pricing.";
  membershipLevel() { return this.stepThreeForm.get('membershipLevel').value }
  cardNumber() { return this.stepThreeForm.get('cardNumber').value }
  cardExpiration() { return this.stepThreeForm.get('cardExpiration').value }
  cvv() { return this.stepThreeForm.get('cvv').value }
  paymentOptions() { return this.stepThreeForm.get('paymentOptions').value }
  autoRenew() { return this.stepThreeForm.get('autoRenew').value }
  declinePacDonation() { return this.stepThreeForm.get('declinePacDonation').value }
  routingNumber() { return this.stepThreeForm.get('routingNumber').value }
  accountNumber1() { return this.stepThreeForm.get('accountNumber1').value }
  accountNumber2() { return this.stepThreeForm.get('accountNumber2').value }
  accountNumbersMatchError() {return this.accountNumber1() != this.accountNumber2()} ;


    ngOnInit() {
        var appType = null;
        this.route.data.subscribe(data => {
            this.specialAppType = data['appType'];
        });

    this.signUpService
      .getminorityCertificateTypes()
      .subscribe(
        {
          next: (data) => {
            this.minorityCertificateTypes = data.minorityCertificateTypes;
            this.numberOfEmpoyeesOptions = data.numberOfEmployeesOptions;
          },
          error: (err) => {
            this.notificationService.error(err);
          },
          complete: () => {
          }
        });

      this.resetStepOneForm();
  }

  private resetStepOneForm(): void {
    this.stepOneForm.reset();
    this.stepOneForm.patchValue({
      firstName: this.applicationRequest.applicantFirstName,
      lastName: this.applicationRequest.applicantLastName,
      emailAddress: this.applicationRequest.applicantEmail,
      phoneNumber: this.applicationRequest.applicantPhoneNumber,
      jobTitle: this.applicationRequest.jobTitle,
      referredBy: this.applicationRequest.referredBy,
      isBillingContact: this.applicationRequest.applicantIsBillingContact,
      billingContactFirstName: this.applicationRequest.billingContactFirstName,
      billingContactLastName: this.applicationRequest.billingContactLastName,
      billingContactEmail: this.applicationRequest.billingContactEmail,
      billingContactPhone: this.applicationRequest.billingContactPhone,
      isKeyContact: this.applicationRequest.applicantIsKeyContact,
      keyContactFirstName: this.applicationRequest.keyContactFirstName,
      keyContactLastName: this.applicationRequest.keyContactLastName,
      keyContactEmail: this.applicationRequest.keyContactEmail,
      keyContactPhone: this.applicationRequest.keyContactPhone,
      brokerName: this.applicationRequest.brokerName,
      brokerEmail: this.applicationRequest.brokerEmail,
    });

    this.stepOneForm.get('isBillingContact').valueChanges.subscribe(val => {
      if (val == false) {
        this.stepOneForm.get('billingContactFirstName').setValidators(Validators.required);
        this.stepOneForm.get('billingContactLastName').setValidators(Validators.required);
        this.stepOneForm.get('billingContactEmail').setValidators([Validators.required, Validators.email]);
        this.stepOneForm.get('billingContactPhone').setValidators(Validators.required);
      }
      else {
        this.stepOneForm.get('billingContactFirstName').clearValidators();
        this.stepOneForm.get('billingContactLastName').clearValidators();
        this.stepOneForm.get('billingContactEmail').clearValidators();
        this.stepOneForm.get('billingContactPhone').clearValidators();
      }
      this.stepOneForm.get('billingContactFirstName').updateValueAndValidity();
      this.stepOneForm.get('billingContactLastName').updateValueAndValidity();
      this.stepOneForm.get('billingContactEmail').updateValueAndValidity();
      this.stepOneForm.get('billingContactPhone').updateValueAndValidity();
    });
    this.stepOneForm.get('isKeyContact').valueChanges.subscribe(val => {
      if (val == false) {
        this.stepOneForm.get('keyContactFirstName').setValidators(Validators.required);
        this.stepOneForm.get('keyContactLastName').setValidators(Validators.required);
        this.stepOneForm.get('keyContactEmail').setValidators([Validators.required, Validators.email]);
        this.stepOneForm.get('keyContactPhone').setValidators(Validators.required);
      }
      else {
        this.stepOneForm.get('keyContactFirstName').clearValidators();
        this.stepOneForm.get('keyContactLastName').clearValidators();
        this.stepOneForm.get('keyContactEmail').clearValidators();
        this.stepOneForm.get('keyContactPhone').clearValidators();
      }
      this.stepOneForm.get('keyContactFirstName').updateValueAndValidity();
      this.stepOneForm.get('keyContactLastName').updateValueAndValidity();
      this.stepOneForm.get('keyContactEmail').updateValueAndValidity();
      this.stepOneForm.get('keyContactPhone').updateValueAndValidity();
    });
      if (this.specialAppType != null && this.specialAppType == 'chambercare') {
          this.stepOneForm.get('brokerName').setValidators(Validators.required);
          this.stepOneForm.get('brokerEmail').setValidators([Validators.required, Validators.email]);
          this.stepOneForm.get('brokerName').updateValueAndValidity();
          this.stepOneForm.get('brokerEmail').updateValueAndValidity();
      }
  }

  private resetSteptwoForm(): void {
    this.stepTwoForm.reset();

    this.stepTwoForm.patchValue({
      companyName: this.applicationRequest.companyName,
      numberOfEmployees: this.applicationRequest.numberOfEmployees,
      businessPhone: this.applicationRequest.businessPhone,
      businessAddress: this.applicationRequest.businessAdress,
      city: this.applicationRequest.city,
      state: this.applicationRequest.state,
      zip: this.applicationRequest.zip,
      isAlaskanNative: this.applicationRequest.isAlaskanOwned,
      isAsianOwned: this.applicationRequest.isAsianOwned,
      isBlackOwned: this.applicationRequest.isBlackOwned,
      isDisabilityOwned: this.applicationRequest.isDisabilityOwned,
      isHispanicOwned: this.applicationRequest.isHispanicOwned,
      isLGBTQOwned: this.applicationRequest.isLGBTQOwned,
      isVeteranOwned: this.applicationRequest.isVeteranOwned,
      isWomenOwned: this.applicationRequest.isWomenOwned,
      isOtherMinorityOwned: this.applicationRequest.isOtherMinorityOwned,
      noneOfTheAbove: this.applicationRequest.noneOfTheAbove,
      isMinorityOwnedCertified: this.applicationRequest.isMinorityOwnedCertified,
      minorityOwnedCertificates: this.applicationRequest.minorityOwnedCertificates
    });


    this.stepTwoForm.get('isMinorityOwnedCertified').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.get('minorityOwnedCertificates').setValidators(Validators.required);
      }
      else {
        this.stepTwoForm.get('minorityOwnedCertificates').clearValidators();
      }
      this.stepTwoForm.get('minorityOwnedCertificates').updateValueAndValidity();
    });
    this.stepTwoForm.get('isAlaskanNative').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isAsian').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isBlack').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isDisability').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isHispanic').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isLgbtq').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isVeteran').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isWomen').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('isOtherMinority').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          noneOfTheAbove: false
        });
        this.stepTwoForm.get('noneOfTheAbove').updateValueAndValidity();
      }
    });
    this.stepTwoForm.get('noneOfTheAbove').valueChanges.subscribe(val => {
      if (val == true) {
        this.stepTwoForm.patchValue({
          isAlaskanNative: false,
          isAsian: false,
          isBlack: false,
          isDisability: false,
          isHispanic: false,
          isLgbtq: false,
          isVeteran: false,
          isWomen: false,
          isOtherMinority: false
        });
        this.stepTwoForm.get('isAlaskanNative').updateValueAndValidity();
        this.stepTwoForm.get('isAsian').updateValueAndValidity();
        this.stepTwoForm.get('isBlack').updateValueAndValidity();
        this.stepTwoForm.get('isDisability').updateValueAndValidity();
        this.stepTwoForm.get('isHispanic').updateValueAndValidity();
        this.stepTwoForm.get('isLgbtq').updateValueAndValidity();
        this.stepTwoForm.get('isVeteran').updateValueAndValidity();
        this.stepTwoForm.get('isWomen').updateValueAndValidity();
        this.stepTwoForm.get('isOtherMinority').updateValueAndValidity();
      }

    });

  }

  private resetStepThreeForm(): void {
    this.stepThreeForm.reset();
    this.stepThreeForm.patchValue({
      membershipLevel: this.applicationRequest.membershipLevel,
      paymentOptions: this.applicationRequest.paymentOptions,
      //cardNumber: this.applicationRequest.cardNumber,
      //cardExpiration: this.applicationRequest.cardExpiration,
      //cvv: this.applicationRequest.cvv,
      autoRenew: this.applicationRequest.autoRenew,
      termsAndConditions: false,
      declinePacDonation: false,
      privacyPolicy: false
    });

      this.stepThreeForm.get('membershipLevel').valueChanges.subscribe(valString => {
        var price = CommonLibrary.getMembershipPriceForLevel(valString, this.applicationRequest.numberOfEmployees);
        this.estimatedPrice = price;
    });
    this.stepThreeForm.get('paymentOptions').valueChanges.subscribe(val => {
      this.stepThreeForm.get('cardNumber').clearValidators();
      this.stepThreeForm.get('cardExpiration').clearValidators();
      this.stepThreeForm.get('cvv').clearValidators();
      if (val == 1) {
        this.stepThreeForm.get('cardNumber').setValidators([Validators.required, Validators.minLength(13), Validators.maxLength(16)]);
        this.stepThreeForm.get('cardExpiration').setValidators(Validators.required);
          this.stepThreeForm.get('cvv').setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(4)]);
      }
      else if (val == 2) {
          this.stepThreeForm.get('routingNumber').setValidators([Validators.required, Validators.maxLength(9)]);
          this.stepThreeForm.get('accountNumber1').setValidators([Validators.required, Validators.maxLength(17)]);
          this.stepThreeForm.get('accountNumber2').setValidators([Validators.required, Validators.maxLength(17)]);
      }
      this.stepThreeForm.get('routingNumber').updateValueAndValidity();
      this.stepThreeForm.get('accountNumber1').updateValueAndValidity();
      this.stepThreeForm.get('accountNumber2').updateValueAndValidity();
      this.stepThreeForm.get('cardNumber').updateValueAndValidity();
      this.stepThreeForm.get('cardExpiration').updateValueAndValidity();
      this.stepThreeForm.get('cvv').updateValueAndValidity();
    });
    if (this.specialAppType == 'startup') {
        this.stepThreeForm.patchValue({ membershipLevel: "9" });
    }
    if (this.specialAppType == 'chambercare') {
        this.stepThreeForm.patchValue({ membershipLevel: "12" });
    }
  }

  stepForward() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    switch (this.currentStep) {
      case 1:
        this.saveStepOne();
            var success = this.validateStepOne();
        if (success) {
          this.resetSteptwoForm();
          this.currentStep = 2;
        }
        break;
      case 2:
        this.saveStepTwo();
        var success = this.validateStepTwo();
          if (success) {
          this.resetStepThreeForm();
          this.currentStep = 3;
        }
        break;
      case 3:
        this.saveStepThree();
        var success = this.validateStepThree();
        if (success) {
          this.submitApplication();
        }
        break;
    }

  }

  stepBack() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    switch (this.currentStep) {
      case 1:
        break;
      case 2:
        this.resetStepOneForm();
        this.saveStepTwo();
        this.currentStep = 1;
        break;
      case 3:
        this.saveStepThree();
        this.currentStep = 2;
    }
  }

  submitApplication() {
    this.blockUI.start();

    this.signUpService.submitGeneralApplication(this.applicationRequest).subscribe(
      {
        next: (data) => {
          this.blockUI.stop();
          if (data == true) {
            this.onFinalStep = true;
          }
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          console.log(err)
          this.blockUI.stop();
        },
        complete: () => {
        }
      });;

  }

  validateStepOne(): boolean {
    for (var i in this.stepOneForm.controls) {
      this.stepOneForm.controls[i].markAsTouched();
    }
    if (!this.stepOneForm.valid) {
      return false;
    }

    return true;

  }
  validateStepTwo(): boolean {
    for (var i in this.stepTwoForm.controls) {
      this.stepTwoForm.controls[i].markAsTouched();
    }
    if (!this.stepTwoForm.valid) {
      return false;
    }
    return true;
  }
    validateStepThree(): boolean {   
    for (var i in this.stepThreeForm.controls) {
      this.stepThreeForm.controls[i].markAsTouched();
    }
    if (!this.stepThreeForm.valid) {
      return false;
    }
    if (this.accountNumbersMatchError()) {
      return false;
    }

    return true;
  }
  saveStepOne() {
    this.applicationRequest.applicantFirstName = this.firstName();
    this.applicationRequest.applicantFirstName = this.firstName();
    this.applicationRequest.applicantLastName = this.lastName();
    this.applicationRequest.applicantEmail = this.emailAddress();
    this.applicationRequest.applicantPhoneNumber = this.phoneNumber();
    this.applicationRequest.jobTitle = this.jobTitle();
    this.applicationRequest.referredBy = this.referredBy();
    this.applicationRequest.applicantIsBillingContact = this.isBillingContact();
    this.applicationRequest.billingContactFirstName = this.billingContactFirstName();
    this.applicationRequest.billingContactLastName = this.billingContactLastName();
    this.applicationRequest.billingContactEmail = this.billingContactEmail();
    this.applicationRequest.billingContactPhone = this.billingContactPhone();
    this.applicationRequest.applicantIsKeyContact = this.isKeyContact();
    this.applicationRequest.keyContactFirstName = this.keyContactFirstName();
    this.applicationRequest.keyContactLastName = this.keyContactLastName();
    this.applicationRequest.keyContactEmail = this.keyContactEmail();
    this.applicationRequest.keyContactPhone = this.keyContactPhone();
    this.applicationRequest.brokerName = this.brokerName();
    this.applicationRequest.brokerEmail = this.brokerEmail();
  }
  saveStepTwo() {
    this.applicationRequest.companyName = this.companyName();
    this.applicationRequest.numberOfEmployees = this.numberOfEmployees();
    this.applicationRequest.businessPhone = this.businessPhone();
    this.applicationRequest.businessAdress = this.businessAddress();
    this.applicationRequest.city = this.city();
    this.applicationRequest.state = this.state();
    this.applicationRequest.zip = this.zip();

    if (this.isAlaskanNative())
      this.applicationRequest.isAlaskanOwned = this.isAlaskanNative();
    if (this.isAsian())
      this.applicationRequest.isAsianOwned = this.isAsian();
    if (this.isBlack())
      this.applicationRequest.isBlackOwned = this.isBlack();
    if (this.isDisability())
      this.applicationRequest.isDisabilityOwned = this.isDisability();
    if (this.isHispanic())
      this.applicationRequest.isHispanicOwned = this.isHispanic();
    if (this.isLgbtq())
      this.applicationRequest.isLGBTQOwned = this.isLgbtq();
    if (this.isVeteran())
      this.applicationRequest.isVeteranOwned = this.isVeteran();
    if (this.isWomen())
      this.applicationRequest.isWomenOwned = this.isWomen();
    if (this.isOtherMinority())
      this.applicationRequest.isOtherMinorityOwned = this.isOtherMinority();
    if (this.noneOfTheAbove())
      this.applicationRequest.noneOfTheAbove = this.noneOfTheAbove();

    this.applicationRequest.isMinorityOwnedCertified = this.isMinorityOwnedCertified();
    this.applicationRequest.minorityOwnedCertificates = this.minorityOwnedCertificates();
  }
  saveStepThree() {
    this.applicationRequest.membershipLevel = this.membershipLevel();
    this.applicationRequest.paymentOptions = this.paymentOptions();
    this.applicationRequest.cardNumber = this.cardNumber();
    this.applicationRequest.cardExpiration = this.cardExpiration();
    this.applicationRequest.cvv = this.cvv();
    this.applicationRequest.routingNumber = this.routingNumber();
    this.applicationRequest.accountNumber1 = this.accountNumber1();
    this.applicationRequest.accountNumber2 = this.accountNumber2();
    this.applicationRequest.autoRenew = this.autoRenew();
    this.applicationRequest.declinePacDonation = this.declinePacDonation();

    }
    finalButtonClick() {
        window.open("https://indychamber.com/", "_blank");
    }
}



